<template>
  <page-view>
    <a-row :gutter="24">
      <a-col :md="12" :sm="24" :style="{ marginBottom: '24px' }">
        <account-index ref="accountIndex"></account-index>
      </a-col>
      <a-col :md="12" :sm="24" :style="{ marginBottom: '24px' }">
        <card-index ref="cardIndex" @ok="handleCardOk"></card-index>
      </a-col>
    </a-row>
    <a-card
      :bordered="false"
      :tabList="[{ key: 'account', tab: '账单明细' }, { key: 'card', tab: '卡密仓库' }]"
      :activeTabKey="noTitleKey"
      @tabChange="key => noTitleKey = key"
    >
      <account-bill v-if="noTitleKey=='account'" ref="accountBill"></account-bill>
      <card-bill v-if="noTitleKey=='card'" ref="cardBill"></card-bill>
    </a-card>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import { PageView } from '@/layouts'
import { getInfo } from '@/api/login'
import AccountIndex from '@/views/property/account/index'
import CardIndex from '@/views/property/card/index'
import AccountBill from './account/bill'
import CardBill from './card/bill'
export default {
  name: 'PropertyCenter',
  components: {
    PageView,
    STable,
    AccountIndex,
    CardIndex,
    AccountBill,
    CardBill
  },
  data() {
    return {
      noTitleKey: 'account'
    }
  },
  filters: {},
  created() {},
  methods: {
    handleCardOk() {
      this.$refs.accountIndex.getData()
      if(this.noTitleKey=="account"){
        this.$refs.accountBill.refresh()
      }else if(this.noTitleKey=="card"){
        this.$refs.cardBill.refresh()
      }  
    }
  }
}
</script>
<style lang="less" scoped>
</style>
